import type { LivenessErrorType } from '@/types/liveness'

const AWS_ERROR_NAME_MAP: Record<string, LivenessErrorType> = {
  AccessDeniedException: 'liveness_access_denied',
  AccessDenied: 'liveness_access_denied',
  LightingCheckFailed: 'poor_lighting',
  FaceNotFound: 'face_misaligned',
  MultipleFacesFound: 'face_misaligned',
  FaceDistanceTooFar: 'face_misaligned',
  SessionTimedOut: 'timeout_abandon',
  SessionExpired: 'timeout_abandon',
  CameraPermissionDenied: 'device_error',
  CameraNotFound: 'device_error',
}

const LIVENESS_STATE_MAP: Record<string, LivenessErrorType> = {
  CONNECTION_TIMEOUT: 'timeout_abandon',
  TIMEOUT: 'timeout_abandon',
  FRESHNESS_TIMEOUT: 'timeout_abandon',
  CAMERA_ACCESS_ERROR: 'device_error',
  DEFAULT_CAMERA_NOT_FOUND_ERROR: 'device_error',
  CAMERA_FRAMERATE_ERROR: 'device_error',
  FACE_DISTANCE_ERROR: 'face_misaligned',
  MULTIPLE_FACES_ERROR: 'face_misaligned',
  SERVER_ERROR: 'generic_liveness',
  RUNTIME_ERROR: 'generic_liveness',
  CREDENTIALS_ERROR: 'liveness_access_denied',
  MOBILE_LANDSCAPE_ERROR: 'generic_liveness',
}

export function resolveLivenessError(error: unknown): LivenessErrorType {
  if (error !== null && typeof error === 'object') {
    const state =
      'state' in error && typeof error.state === 'string' ? error.state : undefined
    if (state !== undefined && state in LIVENESS_STATE_MAP) {
      return LIVENESS_STATE_MAP[state] as LivenessErrorType
    }

    const nested =
      'error' in error && error.error !== null && typeof error.error === 'object'
        ? error.error
        : null
    if (nested !== null) {
      const nestedName =
        'name' in nested && typeof nested.name === 'string' ? nested.name : undefined
      if (nestedName !== undefined && nestedName in AWS_ERROR_NAME_MAP) {
        return AWS_ERROR_NAME_MAP[nestedName] as LivenessErrorType
      }
    }

    const name = 'name' in error && typeof error.name === 'string' ? error.name : undefined
    const code = 'code' in error && typeof error.code === 'string' ? error.code : undefined
    const key = name ?? code
    if (key !== undefined && key in AWS_ERROR_NAME_MAP) {
      return AWS_ERROR_NAME_MAP[key] as LivenessErrorType
    }
  }
  return 'generic_liveness'
}
